import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[uc-host]',
})
export class UCDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}